module.exports = __webpack_public_path__ + "static/20141025_132514-0d5c01218488c5084396ba562488d12c.jpg";